import "babel-polyfill";
import Es6Promise from 'es6-promise'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
//import rem from './rem'
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import 'element-ui/lib/theme-chalk/index.css';
import {messages} from './components/common/i18n';
import './assets/css/icon.css';
import './components/common/directives';
import '@/assets/scss/parentsoncommon.scss'
import '@/assets/scss/peditcommon.scss'

//import './assets/css/theme-green/index.css';

require('es6-promise').polyfill();

Es6Promise.polyfill();
let port = (window.location.port === "" || window.location.port === "80") ? "" : ":" + window.location.port;
axios.defaults.baseURL = document.location.protocol + '//' + window.location.hostname + port + '/api'
console.log(axios.defaults.baseURL)
// axios.defaults.baseURL = 'http://huiyi.59huiyi.com/api'
if (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost") {
    axios.defaults.baseURL = 'http://127.0.0.1/api'
}
try {
    localStorage.setItem("url", axios.defaults.baseURL);
} catch {

}

// axios.defaults.headers.common['token'] = localStorage.metiaToken;    
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});
Vue.prototype.$axios = axios;
if (!localStorage.lang) {
    localStorage.lang = 'chs';
}
const i18n = new VueI18n({
    locale: localStorage.lang,
    messages: {
        'chs': require('./assets/languages/chs.json'),
        'zh': require('./assets/languages/zh.json'),
        'en': require('./assets/languages/en.json')
    }
})
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    const role = localStorage.getItem('ms_username');
    console.log(to.path)
    if (!role && to.path !== '/login' && to.path !== '/register' && to.path !== '/group_login') {
        next('/login');
    } else {
        if (to.path !== '/login' && to.path !== '/register' && to.path !== '/group_login') {
            let time = localStorage.getItem('time');
            if (!time || (new Date().getTime() - parseInt(time) > 1000 * 60 * 120)) {
                localStorage.setItem('ms_username', null);
                localStorage.setItem('projectId', null);
                localStorage.setItem('groupUserId', null);
                next('/login');
            } else {
                next();
            }
        } else {
            next();
        }
    }
})

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')